import {
  IReceiptTripItinerary,
  Receipt,
} from "../../../models/receipt/receipt";
import {
  PAYMENT_TX_PAYMENT_METHOD,
  OrderStatus,
} from "../../../models/receipt/types";
import { getMainTitle, getSubtitle, getTimeInfo } from "./receiptStatus.helper";
import { getPoiTimeInfo } from "./receiptPOI.helper";
import { useTranslation } from "react-i18next";

export const useReceiptCardInfo = (orderStatus: OrderStatus, data: Receipt) => {
  const { i18n, t } = useTranslation("webReceipt");
  const lang = i18n.language === "zh" ? "zhHK" : "en";

  const pickup = data?.tripItinerary?.[0] as IReceiptTripItinerary;
  const dropoff = data?.tripItinerary?.[1] as IReceiptTripItinerary;
  const cardType = data.paymentInformation
    ?.paymentMethod as PAYMENT_TX_PAYMENT_METHOD;
  const cardNumber = data.paymentInformation?.cardNumber;
  const pickupTime = getPoiTimeInfo(data?.time);
  const updatedAtPOI = getPoiTimeInfo(data?.updatedAt);

  const pickupDisplayName =
    pickup?.i18n?.[lang]?.displayName || pickup?.i18n?.zhHK?.displayName || "";
  const pickupAddress =
    pickup?.i18n?.[lang]?.formattedAddress ||
    pickup?.i18n?.zhHK?.formattedAddress ||
    "";
  const dropoffDisplayName =
    dropoff?.i18n?.[lang]?.displayName ||
    dropoff?.i18n?.zhHK?.displayName ||
    "";
  const dropoffAddress =
    dropoff?.i18n?.[lang]?.formattedAddress ||
    dropoff?.i18n?.zhHK?.formattedAddress ||
    "";

  const licensePlate = data.driver?.licensePlate || "";
  const carModel = data.driver?.vehicle?.model || "";
  const carMake = data.driver?.vehicle?.make || "";
  const driverName =
    lang === "zhHK"
      ? data.driver?.nameZh || data.driver?.name || ""
      : data.driver?.name || data.driver?.nameZh || "";

  const driverPhone = data.driver?.phoneNumber || "";
  const driverObj = data?.driver;
  const mainTitle = getMainTitle(
    t,
    orderStatus,
    data?.time,
    dropoffDisplayName,
    data?.eta,
    data.status,
    pickupDisplayName
  );
  const subTitle = getSubtitle(t, orderStatus, data?.updatedAt, data?.eta, data.status);
  const timeInfo = getTimeInfo(t, orderStatus, data?.time, data?.eta);

  const total = data?.total || 0;
  const cancellationFee = data?.cancellationFee || 0;

  const carIcon = data.driver?.vehicle?.iconUrl || "";
  const encodedPolyline = data?.encodedPolyline || "";

  const hotelPhone = data?.supportContactPhoneNumber || data?.organization?.settings?.webHailingPage?.supportContactPhoneNumber || "";

  const status = data.status;

  const clientType = data?.clientType || "";
  const isShowSupportContact = data?.organization?.settings?.webHailingPage?.isShowSupportContact || false;
  const type = data?.type || "";

  return {
    pickup,
    dropoff,
    cardType,
    cardNumber,
    pickupTime,
    updatedAtPOI,
    pickupDisplayName,
    pickupAddress,
    dropoffDisplayName,
    dropoffAddress,
    licensePlate,
    carModel,
    carMake,
    driverName,
    driverPhone,
    driverObj,
    mainTitle,
    subTitle,
    timeInfo,
    total,
    carIcon,
    encodedPolyline,
    hotelPhone,
    cancellationFee,
    status,
    clientType,
    isShowSupportContact,
    type
  };
};
